// src/index.js
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async'; // <<< NOUVEL IMPORT
import './i18n'; // Ton fichier de configuration i18next
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import reportWebVitals from './reportWebVitals';

// Apply saved theme before React mounts for no-flash and persistence
try {
  const savedTheme = localStorage.getItem('theme');
  let useDark = false;
  if (savedTheme === 'dark') useDark = true;
  else if (savedTheme === 'light') useDark = false;
  else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) useDark = true;
  document.body.classList.toggle('dark', useDark);
} catch {}

const LoadingFallback = () => (
  <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh', 
      fontSize: '1.2rem',
      fontFamily: 'var(--font-family-sans-serif, sans-serif)',
      color: 'var(--text-color, #333)'
    }}>
    Chargement du contenu...
  </div>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<LoadingFallback />}>
      <HelmetProvider> {/* <<< AJOUT DE HelmetProvider ICI */}
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </Suspense>
  </React.StrictMode>
);

reportWebVitals();